import Swal, { SweetAlertIcon } from 'sweetalert2';
import { HttpHeaders } from '@angular/common/http';

export class UturuncoUtils {
    public static RF: any = "refresh";
    public static UC: any = "user-compr";
    public static CC: any = "carrito";

    public static setSession(key: string, data: string) {
        localStorage.setItem(key, data);
    }

    public static getSession(key: string) {
        return localStorage.getItem(key);
    }

    public static removeItemSession(key: string) {
        localStorage.removeItem(key);
    }

    public static getToken() {
        return localStorage.getItem("loginAuth");
    }

    public static setToken(token: any) {
        localStorage.setItem("loginAuth", token);
    }

    public static clearSession() {
        localStorage.clear();
    }

    public static getHeader() {
        let uid = "";
        try {
            uid = JSON.parse(localStorage.getItem("user")).uid
        } catch (error) {

        }
        const header = new HttpHeaders(
            {
                "X-Auth-Token": "" + localStorage.getItem("loginAuth"),
                //"uid": uid
            }
        );

        return header;
    }

    public static showToas(msg: string, type: SweetAlertIcon) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: type,
            title: msg
        });
    }


    public static expirado(fechaExp: number) {
        let ahora = new Date().getTime() / 1000
        return fechaExp < ahora
    }



}
